import { createElement } from 'react';
import classnames from 'classnames';
import Svg from './svg';
import './index.less';
const TitleBar6 = ({ width = 460, height = 36, color = '#4B9FFF', title, subTitle, style, simple, extra, extraStyle, }) => {
    return (createElement("div", { className: "dv-title-bar", style: {
            width,
            height,
            ...(style || {}),
        } },
        createElement(Svg, { color: color, width: width, height: height }),
        createElement("div", { className: classnames('dv-title-bar-content dv-title-bar-6', {
                simple: !!simple,
            }) },
            createElement("div", { className: "dv-title-bar-title" }, title),
            subTitle ? createElement("div", { className: "dv-title-bar-sub-title" }, subTitle) : null),
        extra && (createElement("div", { className: "dv-title-bar-extra", style: extraStyle }, extra))));
};
export default TitleBar6;
